import dynamic from 'next/dynamic';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useSimilarListings } from '@/hooks/queries/useSimilarListings';

const SimilarProperties = dynamic(() =>
  import('@/components/property-expose/SimilarProperties/SimilarProperties').then((mod) => mod.SimilarProperties),
);

export const DynamicSimilarProperties = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const { data: similarListings } = useSimilarListings();
  if (!similarListings || similarListings.length === 0 || isUAExclusiveListingAndNotSignedIn) return null;

  return <SimilarProperties similarListings={similarListings} />;
};
